import { render, staticRenderFns } from "./entry-info-team.vue?vue&type=template&id=dffb2e84&scoped=true&"
import script from "./entry-info-team.vue?vue&type=script&lang=js&"
export * from "./entry-info-team.vue?vue&type=script&lang=js&"
import style0 from "./entry-info-team.vue?vue&type=style&index=0&id=dffb2e84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffb2e84",
  null
  
)

export default component.exports